import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import { categories } from './writeupdata';

function WriteUpsSection() {
    const [writeups, setWriteups] = useState([]);

    useEffect(() => {
        fetchWriteups();
    }, []);

    const fetchWriteups = async () => {
        try {
            const response = await fetch('https://usscfedora.org/public_writeups.php');
            const data = await response.json();
            if (data.status === 'success') {
                setWriteups(data.writeups);
            }
        } catch (error) {
            console.error('Error fetching writeups:', error);
        }
    };

    return (
        <section className="landing-page-writeups">
            <Container fluid>
                <Row className="justify-content-center">
                    <Col md={10} lg={8} className="text-center mb-5">
                        <h2 className="landing-page-writeups-title high-tech-font">Write-Ups</h2>
                        <div className="landing-page-writeups-underline"></div>
                        <p className="landing-page-writeups-subtitle">Our CTF challenge solutions and guides</p>
                    </Col>
                </Row>

                <Row className="justify-content-center g-4">
                    {writeups.map((writeup) => (
                        <Col key={writeup.id} md={6} lg={4}>
                            <a 
                                href={writeup.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="landing-page-writeup-card-link"
                            >
                                <div className="landing-page-writeup-card">
                                    <div 
                                        className="landing-page-writeup-category-icon"
                                        style={{
                                            background: categories[writeup.category]?.gradient
                                        }}
                                    >
                                        <FontAwesomeIcon 
                                            icon={categories[writeup.category]?.icon} 
                                            className="icon"
                                        />
                                    </div>
                                    <div className="landing-page-writeup-content">
                                        <div className="landing-page-writeup-meta">
                                            <span className="landing-page-writeup-category">
                                                {writeup.category}
                                            </span>
                                            <span className="landing-page-writeup-date">
                                                {writeup.date}
                                            </span>
                                        </div>
                                        <h3 className="landing-page-writeup-title">
                                            {writeup.title}
                                        </h3>
                                        <p className="landing-page-writeup-description">
                                            {writeup.description}
                                        </p>
                                        <div className="landing-page-writeup-author">
                                            <FontAwesomeIcon icon={faUser} className="author-icon" />
                                            <span>{writeup.author}</span>
                                        </div>
                                        <div className="landing-page-writeup-footer">
                                            <span className="landing-page-writeup-ctf">
                                                {writeup.ctf}
                                            </span>
                                            <span className="landing-page-writeup-readtime">
                                                {writeup.read_time}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
}

export default WriteUpsSection;